/** 
 * @type {import("./defs").StoreMediaFile} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreMediaFile} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreMediaFile.js